import back from "./back.svg";

export default function BackIcon() {
  return (
    <img src={back} />
  );
}